export default __webpack_public_path__ + "static/media/Forcesight_Logo.6fa9eca9.svg";